import React from "react";
import {
  Users,
  TrendingUp,
  UserPlus,
  DollarSign,
  IndianRupee,
  Info,
  ListTodo,
  ClipboardCheck,
  Package,
  FileText,
  CreditCard,
  Sun,
  TowerControl as Tower,
  Phone,
  CheckSquare,
  Wallet,
  User,
  Shield,
  Wrench,
  Calculator,
  Layout,
} from "lucide-react";

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Karnataka",
  "Tamil Nadu",
  "Telangana",
];

export const ADMIN_TABLE_HEADERS = [
  "Verve ID",
  "Contact Details",
  "Source",
  "Reference",
  "Location",
  "Telecaller Name",
  "Tele Status",
  "Last Note",
  "Actions",
];

export const CONTACT_STAGES = [
  {
    key: "new",
    label: "New Contact",
    color: "border-blue-300 bg-blue-50 text-blue-700",
  },
  {
    key: "assigned",
    label: "Assigned",
    color: "border-indigo-300 bg-indigo-50 text-indigo-700",
  },
  {
    key: "not_reachable",
    label: "Not Reachable",
    color: "border-orange-300 bg-orange-50 text-orange-700",
  },
  {
    key: "not_answered",
    label: "Not Answered",
    color: "border-amber-300 bg-amber-50 text-amber-700",
  },
  {
    key: "not_interested",
    label: "Not Interested",
    color: "border-rose-300 bg-rose-50 text-rose-700",
  },
  {
    key: "contact_later",
    label: "Contact Later",
    color: "border-purple-300 bg-purple-50 text-purple-700",
  },
  {
    key: "duplicate",
    label: "Duplicate Customer",
    color: "border-slate-300 bg-slate-50 text-slate-500",
  },
  {
    key: "interested",
    label: "Interested",
    color: "border-emerald-300 bg-emerald-50 text-emerald-700",
  },
  {
    key: "appointment_scheduled",
    label: "Appointment Scheduled",
    color: "border-orange-300 bg-orange-50 text-orange-700",
  },
  {
    key: "site_visit",
    label: "Site Visit",
    color: "border-teal-300 bg-teal-50 text-teal-700",
  },
  { /* Developer : Nithin - Moved from Leads to Contacts */
    key: "initial_design",
    label: "Initial Design",
    color: "border-pink-300 bg-pink-50 text-pink-700",
  },
  {
    key: "initial_quotation",
    label: "Initial Quotation",
    color: "border-cyan-300 bg-cyan-50 text-cyan-700",
  },
  {
    key: "client_approval",
    label: "Client Approval",
    color: "border-sky-300 bg-sky-50 text-sky-700",
  },
  {
    key: "converted",
    label: "Converted",
    color: "border-green-300 bg-green-100 text-green-700",
  },
  {
    key: "drop",
    label: "Dropped",
    color: "border-rose-300 bg-rose-50 text-rose-700",
  },
];

export const INITIAL_CUSTOMER_FORM = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  address1: "",
  address2: "",
  city: "",
  district: "",
  state: "",
  pincode: "",
  propertyType: "Residential",
  serviceType: "Verve",
  capacity: "",
  towerHeight: "",
  notes: "",
  source: "Manual",
  budget: "",
  referenceType: "",
  employeeId: "",
  referenceDetails: "",
  officeLocation: "",
  VerveRequirement: "",
  electricityBillRange: "",
  status: "new",
};

export const QUICK_DATE_PRESETS = [
  { id: "today", label: "T", title: "Today" },
  { id: "this_week", label: "W", title: "This Week" },
  { id: "this_month", label: "M", title: "This Month" },
  { id: "this_year", label: "Y", title: "This Year" },
];

export const REFERENCE_SOURCES = [
  "Direct",
  "Facebook",
  "Instagram",
  "Youtube",
  "Whatsapp",
  "",
  "Website",
  "Just Dail",
  "Indiamart",
  "Google",
  "Call Center",
  "Technician / Lineman",
  "Others",
];

export const Verve_REQUIREMENTS = ["Home", "Commercial"];

export const PROPERTY_TYPES = [
  "Residential",
  "Commercial",
  "Industrial",
  "Agricultural",
];

export const SERVICE_TYPES = ["Verve", "tower"];

export const PRIORITY_OPTIONS = ["low", "medium", "high", "urgent"];

export const INTEREST_LEVEL_OPTIONS = [
  { value: "none", label: "None" },
  { value: "not-picked", label: "Not Picked" },
  { value: "interested", label: "Interested" },
  { value: "highly-interested", label: "Highly Interested" },
  { value: "plan-6months", label: "Planning (6 Months)" },
  { value: "plan-1year", label: "Planning (1 Year)" },
  { value: "closed", label: "Closed" },
  { value: "not-interested", label: "Not Interested" },
];

export const SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
  { value: "name_a_z", label: "Name (A-Z)" },
];

/**
 * Derived Status Colors from CONTACT_STAGES
 */
export const STATUS_COLORS = CONTACT_STAGES.reduce(
  (acc, stage) => {
    acc[stage.key] = stage.color;
    return acc;
  },
  {
    // Add any extra statuses that might not be in CONTACT_STAGES
    quotation: "border-amber-300 bg-amber-50 text-amber-700",
    quote_sent: "border-amber-300 bg-amber-50 text-amber-700",
    project_started: "border-teal-300 bg-teal-50 text-teal-700",
    project_start: "border-teal-300 bg-teal-50 text-teal-700",
    installation_started: "border-sky-300 bg-sky-50 text-sky-700",
  },
);

export const TELECALLER_TABLE_HEADERS = [
  "Verve ID",
  "Contact Details",
  "Source",
  "Reference",
  "Location",
  "Status",
  "Call",
  "Last Note",
  "Next Stage",
  "Actions",
];

export const VIEW_TABS = [
  { id: "uploads", label: "Files History" },
  { id: "assign", label: "Contacts" },
];

export const VIEW_STYLES = [
  { id: "kanban", icon: "⬛", label: "Kanban" },
  { id: "table", icon: "≡", label: "Table" },
];

export const STATUS_VARIANT_MAP = {
  new: "info",
  assigned: "indigo",
  converted: "success",
  appointed: "success",
  contacted: "orange",
  site_visit: "purple",
  inspection_done: "teal",
  inspected: "teal",
  initial_quotation: "amber",
  // New Lead Stages
  advance_payment_10: "indigo",
  initial_design: "pink",
  budget: "warning",
  sign_of_copy: "info",
  advance_payment_50: "primary",
  prod_drawings: "purple",
  order_placing: "orange",
  final_payment: "success",
  delivery: "teal",
  
  // Legacy / Old Stages (Commented or kept for safety)
  // customer_acceptance: "indigo",
  // cust_acceptance: "indigo",
  // design: "purple",
  // final_quotation: "orange",
  // quotation_approval: "success",
  // documents: "neutral",
  // quotation_sent: "amber",
  // quotation: "amber",
  // approved: "success",
  // appointment_scheduled: "orange",
  // project_started: "teal",
  // started: "teal",
  // in_progress: "amber",
  // completed: "success",
  default: "neutral",
};

export const getLeadsFilterConfig = (filterOptions = {}, leadStages = []) => [
  {
    key: "status",
    label: "Status",
    options: leadStages.map((s) => ({ value: s.key, label: s.label })),
    placeholder: "All Stages",
  },
  {
    key: "location",
    label: "City",
    options:
      filterOptions?.locations?.map((loc) => ({ value: loc, label: loc })) ||
      [],
    placeholder: "All Locations",
  },
  {
    key: "source",
    label: "Source",
    options:
      filterOptions?.sources?.map((src) => ({
        value: src.toLowerCase(),
        label: src,
      })) || [],
    placeholder: "All Sources",
  },
  ...(filterOptions.assignees
    ? [
        {
          key: "assignee",
          label: "Assignee",
          options: filterOptions.assignees.map((a) => ({
            value: a.id,
            label: a.name,
          })),
          placeholder: "Any Assignee",
        },
      ]
    : []),
];

export const LEAD_STAGES = [
  { key: "new", label: "New Lead", color: "border-emerald-300 bg-emerald-50 text-emerald-800" },
  // { key: "advance_payment_10", label: "Advance Payment 10%", color: "border-indigo-300 bg-indigo-50 text-indigo-700" },
  /* Developer : Nithin - Removed initial_design here because it was moved to Contacts */
  // { key: "initial_quotation", label: "Initial Quotation", color: "border-cyan-300 bg-cyan-50 text-cyan-700" },
  { key: "budget", label: "Budget", color: "border-yellow-300 bg-yellow-50 text-yellow-700" },
  { key: "sign_of_copy", label: "Sign Of Copy", color: "border-cyan-300 bg-cyan-50 text-cyan-700" },
  // { key: "advance_payment_50", label: "Advance Payment 50%", color: "border-blue-300 bg-blue-50 text-blue-700" },
  { key: "prod_drawings", label: "Prod Drawings", color: "border-purple-300 bg-purple-50 text-purple-700" },
  { key: "order_placing", label: "Orderings", color: "border-orange-300 bg-orange-50 text-orange-700" },
  { key: "final_payment", label: "Final Payment", color: "border-green-300 bg-green-50 text-green-700" },
  { key: "delivery", label: "Delivery", color: "border-teal-300 bg-teal-50 text-teal-700" },
];

export const PROJECT_PIPELINE_STAGES = [
  { key: "design", label: "Design", color: "border-violet-300 bg-violet-50" },
  {
    key: "design_approval",
    label: "Design Approval",
    color: "border-fuchsia-300 bg-fuchsia-50 text-fuchsia-800",
  },
  {
    key: "final_quotation",
    label: "Final Quotation",
    color: "border-orange-300 bg-orange-50",
  },
  {
    key: "quotation_approval",
    label: "Final Quotation Approval",
    color: "border-green-300 bg-green-50",
  },
  {
    key: "documents",
    label: "Sign Off",
    color: "border-slate-300 bg-slate-50",
  },
  {
    key: "project_started",
    label: "Started",
    color: "border-teal-300 bg-teal-50",
  },
];

export const getCumulativeStatuses = (currentStatus) => {
  if (!currentStatus || currentStatus === "all") return undefined;
  const stages = LEAD_STAGES.map((stage) => stage.key);
  const startIndex = stages.indexOf(currentStatus);
  if (startIndex === -1) return currentStatus; // fallback
  return stages.slice(startIndex).join(",");
};

export const DESIGN_STAGES = [
  {
    key: "started",
    label: "Started",
    color: "border-teal-300 bg-teal-50 text-teal-800",
  },
  {
    key: "in_progress",
    label: "In Progress",
    color: "border-amber-300 bg-amber-50 text-amber-800",
  },
  {
    key: "completed",
    label: "Completed",
    color: "border-emerald-300 bg-emerald-50 text-emerald-800",
  },
];

export const MANAGE_STAGES_TEXT = "Manage Stages";

export const LEAD_TABLE_HEADERS = {
  Verve_ID: "Verve ID",
  CUSTOMER: "Customer",
  PHONE: "Phone",
  CITY: "City",
  CAPACITY: "Capacity (kW)",
  BUDGET: "Budget (₹)",
  SOURCE: "Source",
  REFERENCE: "Reference",
  STATUS: "Lead Status",
  TELE_INFO: "Telecaller Info",
  CREATED: "Created",
  SALES_EXEC: "Sales Exec",
  PROJECT_MGR: "Project Manager",
  CALL: "Call",
  ACTIONS: "Actions",
};

export const getLeadStatsConfig = (stats, fmt) => {
  return [
    {
      title: "Total Leads",
      value: stats.converted || 0,
      color: "bg-brand-blue",
      icon: React.createElement(Users, null),
    },
    {
      title: "Conversion Rate",
      value: `${stats.rate || 0}%`,
      color: "bg-brand-orange",
      icon: React.createElement(TrendingUp, null),
    },
    {
      title: "New Leads",
      value: stats.newLeads || 0,
      color: "bg-emerald-500",
      icon: React.createElement(UserPlus, null),
    },
    {
      title: "Pipeline Value",
      value: fmt(stats.budget || 0),
      color: "bg-indigo-600",
      icon: React.createElement(IndianRupee, null),
    },
  ];
};

/**
 * General Expense Constants
 */
export const EXPENSE_CATEGORIES = [
  { key: "general", label: "General Expense" },
  { key: "project", label: "Project Related" },
  { key: "advance", label: "Advance to Customer" },
];

/**
 * Payment methods — icon field references a key into PAYMENT_METHOD_ICONS
 * (icons must be resolved in the component since they're React components)
 */
export const PAYMENT_METHODS = [
  { id: "bank", value: "bank", label: "Bank Transfer", icon: "CreditCard" },
  { id: "upi", value: "upi", label: "UPI / QR", icon: "Smartphone" },
  { id: "cash", value: "cash", label: "Cash", icon: "Banknote" },
  { id: "cheque", value: "cheque", label: "Cheque", icon: "ScrollText" },
];

/**
 * Transaction modes for RecordPaymentModal
 */
export const TRANSACTION_MODES = [
  {
    id: "inflow",
    label: "Payment Received",
    icon: "ArrowDownLeft",
    color: "text-emerald-600",
  },
  {
    id: "outflow",
    label: "Expense Paid",
    icon: "ArrowUpRight",
    color: "text-rose-500",
  },
];

// Backward-compatible alias used by AddGeneralExpenseModal & ExpenseGrid
export const EXPENSE_PAYMENT_METHODS = PAYMENT_METHODS;

export const PROJECT_PAYMENT_TYPES = {
  milestone: "Milestone Payment",
  advance: "Advance Payment",
  final: "Final Settlement",
  extra: "Additional Charges",
  refund: "Customer Refund",
};

export const EXPENSE_STATUSES = [
  { key: "pending", label: "Pending", variant: "warning" },
  { key: "approved", label: "Approved", variant: "success" },
  { key: "paid", label: "Paid", variant: "success" },
  { key: "rejected", label: "Rejected", variant: "danger" },
  { key: "cancelled", label: "Cancelled", variant: "danger" },
];

export const INITIAL_EXPENSE_FORM = {
  amount: "",
  date: new Date().toISOString().split("T")[0],
  reason: "",
  toWhomPaid: "",
  byWhomPaid: "",
  requestedBy: "",
  notes: "",
  relatedToProject: "no",
  relatedProjectId: "",
  category: "general",
};

/**
 * Expense Oversight Constants
 */
export const OVERSIGHT_TABS = [
  { id: "expenses", label: "Expense Oversight", icon: "Receipt" },
  { id: "received", label: "Payments Received", icon: "Wallet" },
];

export const OVERSIGHT_CATEGORIES = [
  { value: "all", label: "All Items" },
  { value: "general", label: "General Expenses" },
  { value: "project", label: "Project Related" },
  { value: "advance", label: "Advance" },
];

export const OVERSIGHT_STATUS_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "paid", label: "Paid" },
  { value: "rejected", label: "Rejected" },
];

/**
 * Accounts Constants
 */
export const ACCOUNT_STAGES = [
  {
    key: "paid",
    label: "Fully Paid",
    variant: "success",
    color: "border-green-300 bg-green-50 text-green-800",
  },
  {
    key: "pending",
    label: "Pending",
    variant: "info",
    color: "border-orange-300 bg-orange-50 text-orange-800",
  },
  {
    key: "partially_paid",
    label: "Partially Paid",
    variant: "warning",
    color: "border-amber-300 bg-amber-50 text-amber-800",
  },
  {
    key: "overpaid",
    label: "Overpaid",
    variant: "purple",
    color: "border-purple-300 bg-purple-50 text-purple-800",
  },
];

export const ACCOUNTS_TABLE_HEADERS = {
  PROJECT_ID: "Project Id",
  CUSTOMER: "Customer",
  DATE: "Date",
  PROJECT_VALUE: "Project Value (₹)",
  TOTAL_RECEIVED: "Total Received (₹)",
  ADVANCE_TO_CUSTOMER: "Advance To Customer",
  OTHER_EXPENSES: "Project Expenses (₹)",
  MATERIAL_EXPENSES: "Material Expenses (₹)",
  TOTAL_EXPENSES: "Total Expenses (₹)",
  BALANCE_DUE: "Balance Due (₹)",
  BUDGET_LEFT: "Budget Left (₹)",
  BALANCE: "Balance (₹)",
  PROJECT_STATUS: "Project Status",
  PAYMENT_STATUS: "Payment Status",
  EXPENSE_STATUS: "Expense Status",
  ACTIONS: "Actions",
};

export const ACCOUNT_STAT_TITLES = {
  FULLY_PAID: "Fully Paid",
  TOTAL_PROJECTS_COST: "Total Projects Cost",
  TOTAL_PAID_BY_CUSTOMERS: "Total Paid By Customers",
  EXPENSES: "Expenses",
};

/**
 * Inventory Constants
 */
export const INVENTORY_TABS = [
  { id: "vendor", label: "Vendors" },
  { id: "brand", label: "Brands" },
  { id: "stores", label: "Stores" },
  // { id: "category", label: "Categories" },
  // { id: "subCategory", label: "Sub Categories" },
  // { id: "item", label: "Items" },
  { id: "unit", label: "Units" },
  // { id: "registeredType", label: "Registered Types" },
];

export const INVENTORY_VIEW_MODES = [
  // { id: "requests", label: "Requests", icon: "FileText" },
  /*
  {
    id: "blum",
    label: "Blum",
    icon: "Package",
    requiredRoles: [
      "owner",
      "admin",
      "systemadmin",
      "tower-admin",
      "Verve-admin",
      'store_incharge',
    ],
  },
  */
  {
    id: "inventory",
    label: "Inventory",
    icon: "Package",
    requiredRoles: [
      "owner",
      "admin",
      "systemadmin",
      "tower-admin",
      "Verve-admin",
      'store_incharge',
      "accountant",
    ],
  },
  // {
  //   id: "returns",
  //   label: "Returns",
  //   icon: "RotateCcw",
  //   requiredRoles: [
  //     "owner",
  //     "admin",
  //     "systemadmin",
  //     "tower-admin",
  //     "Verve-admin",
  //     'store_incharge',
  //     'designer', // Project managers can view site returns for their projects
  //     "accountant",
  //   ],
  // },
  {
    id: "settings",
    label: "Settings",
    icon: "Settings",
    requiredRoles: [
      "owner",
      "admin",
      "systemadmin",
      "tower-admin",
      "Verve-admin",
      'store_incharge',
      "accountant",
    ],
  },
];

export const INVENTORY_SUB_TABS = {
  ITEMS: "items",
  PURCHASES: "purchases",
  BLUM_PURCHASES: "blum_purchases",
  SALES: "sales",
  OPEN_STOCK: "open_stock",
  RETURNS: "returns",
  SETTINGS: "settings",
};

export const RETURNS_SUB_TABS = {
  MASTER: "master",
  SITE: "site",
  SALES: "sales",
  PURCHASES: "purchases",
  DAMAGED: "damaged",
};

export const INITIAL_INVENTORY_FORM = {
  title: "",
  code: "",
  description: "",
  name: "",
  mobile: "",
  email: "",
  address: "",
  serviceType: "Verve",
  active: true,
  status: "ACTIVE",
  openingDate: "",
  state: "",
  district: "",
  gstRegisteredType: "",
  gstNo: "",
  bankIfsc: "",
  bankName: "",
  bankBranch: "",
  bankAccountHolder: "",
  bankAccountNo: "",
  type: "",
  category: "",
  brand: "",
  itemName: "",
  itemCode: "",
  hsnSacCode: "",
  barcode: "",
  units: "",
  itemDescription: "",
  isUnique: false,
  uniqueName: "",
  isBatchExpiry: false,
  bvPoints: 0,
};

export const INVENTORY_TABLE_HEADERS = {
  vendor: [
    "Code",
    "Name",
    "Contact",
    "Address",
    "Created At",
    "Status",
    "Actions",
  ],
  registeredType: [
    "Code",
    "Name",
    "Description",
    "Created At",
    "Status",
    "Actions",
  ],
  item: ["Code", "Name", "Category", "Brand", "Units", "Created At", "Actions"],
  stores: [
    "Code",
    "Name",
    "Address",
    "Contact",
    "Created At",
    "Status",
    "Actions",
  ],
  default: ["Code", "Title", "Description", "Created At", "Status", "Actions"],
};

/** Backend VerveProjectExecution.status enum + labels for UI */
export const EXECUTION_STATUS_FLOW = [
  "not_started",
  "materials_requested",
  "owner_approval",
  "pending_store",
  "materials_dispatched",
  "project_started",
  "installation_completed",
  "balance_update",
  "documents",
  "meter_connection",
  "subsidy",
  "completed",
];

export const EXECUTION_STATUS_LABELS = {
  not_started: "Not started",
  materials_requested: "Material Requested",
  owner_approval: "Owner Approval",
  pending_store: "Pending Store",
  materials_dispatched: "Dispatched",
  project_started: "Project started",
  installation_completed: "Installation completed",
  balance_update: "Balance Update",
  documents: "Sign Off",
  meter_connection: "Meter Connection",
  subsidy: "Subsidy",
  completed: "Completed",
};

export const EXECUTION_STATUS_FILTER = ["all", ...EXECUTION_STATUS_FLOW];

export const EXECUTION_STATUS_FILTER_LABELS = {
  all: "All statuses",
  ...EXECUTION_STATUS_LABELS,
};

/** Tabs that unlock after PM marks project as started (not_started → project_started). */
export const OPS_TABS_AFTER_START = new Set(["inventory", "tasks"]);

export const getCustomerDisplayId = (project) => {
  if (!project) return "";
  const lead =
    project.leadId && typeof project.leadId === "object"
      ? project.leadId
      : project.leadRef && typeof project.leadRef === "object"
        ? project.leadRef
        : null;
};

// Documents Tab Constants
export const DOCUMENT_PHASES = [
  { key: "assign", label: "Assign Sales Person", num: 1 },
  { key: "upload", label: "Upload Documents", num: 2 },
  { key: "approval", label: "Owner Approval", num: 3 },
  { key: "completed", label: "Phase Complete", num: 4 },
];

export const PROJECT_DETAILS_TABS = [
  {
    id: "overview",
    label: "Overview",
    icon: React.createElement(Info, { size: 16 }),
  },
  {
    id: "tasks",
    label: "Tasks",
    icon: React.createElement(ListTodo, { size: 16 }),
  },
  {
    id: "inventory_request",
    label: "Inventory Request",
    icon: React.createElement(ClipboardCheck, { size: 16 }),
  },
  {
    id: "inventory",
    label: "Site Inventory",
    icon: React.createElement(Package, { size: 16 }),
  },
  {
    id: "documents",
    label: "Documents",
    icon: React.createElement(FileText, { size: 16 }),
  },
  // Note: the subsidy tab label changes dynamically based on project type.
  {
    id: "subsidy",
    label: "Meter Connection", // Default
    icon: React.createElement(CreditCard, { size: 16 }),
  },
];

/**
 * Team Management Constants
 */
/*developer: Nithin
    date : 2024-06-19
    changes : Replaced Telecaller With Staff */
export const TEAM_ROLE_OPTIONS = [
  { value: "all", label: "All Roles" },
  { value: "admin", label: "Admin" },
  { value: "sales-head", label: "Sales Head" },
  { value: "sales-exec", label: "Sales Exec." },
  { value: "accountant", label: "Accountant" },
  { value: "account-manager", label: "Account Manager" },
  { value: 'client_coordinator', label: "Client Coordinator" },
  { value: 'designer', label: "Designer" },
  { value: 'store_incharge', label: "Store Incharge" },
  { value: 'installation_team', label: "Installation Team" },
];

export const ROLE_LABELS = {
  owner: "Owner",
  admin: "Admin",
  "sales-head": "Sales Head",
  "sales-exec": "Sales Exec.",
  accountant: "Accountant",
  "account-manager": "Account Manager",
  client_coordinator: "Client Coordinator",
  'designer': "Designer",
  'store_incharge': "Store Incharge",
  installation_team: "Installation Team",
  field_marketing: "Field Marketing",
  social_media: "Social Media",
  "Verve-admin": "Verve Admin",
};

export const ROLE_BADGE_VARIANT = {
  owner: "neutral",
  admin: "indigo",
  "sales-head": "rose",
  "sales-exec": "orange",
  accountant: "teal",
  "account-manager": "cyan",
  client_coordinator: "info",
  'designer': "success",
  'store_incharge': "emerald",
  installation_team: "amber",
  field_marketing: "amber",
  social_media: "indigo",
  "Verve-admin": "danger",
};

export const ROLE_COLORS = {
  owner: "text-slate-800 bg-slate-50 border-slate-200",
  admin: "text-indigo-800 bg-indigo-50 border-indigo-200",
  "sales-head": "text-rose-600 bg-rose-50 border-rose-100",
  "sales-exec": "text-orange-600 bg-orange-50 border-orange-100",
  accountant: "text-yellow-600 bg-yellow-50 border-yellow-100",
  "account-manager": "text-cyan-600 bg-cyan-50 border-cyan-100",
  client_coordinator: "text-blue-600 bg-blue-50 border-blue-100",
  'designer': "text-emerald-600 bg-emerald-50 border-emerald-100",
  installation_team: "text-amber-600 bg-amber-50 border-amber-100",
  "Verve-admin": "text-red-600 bg-red-50 border-red-100",
  "tower-admin": "text-purple-600 bg-purple-50 border-purple-100",
  'store_incharge': "text-green-600 bg-green-50 border-green-100",
  field_marketing: "text-amber-600 bg-amber-50 border-amber-100",
  social_media: "text-indigo-600 bg-indigo-50 border-indigo-100",
};

export const ROLE_ICONS = {
  owner: User,
  admin: Shield,
  "sales-head": TrendingUp,
  "sales-exec": TrendingUp,
  accountant: Calculator,
  "account-manager": Layout,
  client_coordinator: Phone,
  'designer': CheckSquare,
  installation_team: Wrench,
  "Verve-admin": Sun,
  "tower-admin": Tower,
  'store_incharge': Package,
  field_marketing: ClipboardCheck,
  social_media: Layout,
};

export const INITIAL_TEAM_MEMBER_FORM = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  userId: "",
  employeeId: "",
  role: "",
  department: "management",
  password: "",
  reportingManager: "",
  joiningDate: "",
  workLocation: "",
  notes: "",
};

export const TEAM_DEPARTMENT_OPTIONS = [
  { value: "management", label: "Management" },
  //{ value: "hr", label: "HR" },
  { value: "accounts", label: "Accounts" },
  { value: "marketing", label: "Marketing" },
  { value: 'client_coordinator', label: "Client Coordinator" },
  { value: "store", label: "Store / Inventory" },
  { value: "field_staff", label: "Field Staff" },
  { value: "others", label: "Others" },
];
